import { SheetSize } from './PricingContext';

// Standard sheet sizes available in the market - optimized for material cost calculation
export const STANDARD_SHEET_SIZES: SheetSize[] = [
  { width: 20, height: 30 },
  { width: 22, height: 28 },
  { width: 23, height: 36 },
  { width: 25, height: 30 },
  { width: 25, height: 36 },
  { width: 27, height: 34 },
  { width: 30, height: 40 }
];

// DEPRECATED: All calculation functions below should use the backend API instead

// Placeholder exports to prevent import errors
export function findBestFitSheetSize(
  requiredWidth: number, 
  requiredHeight: number, 
  availableSheetSizes: SheetSize[] = STANDARD_SHEET_SIZES,
  actualProductWidth?: number,
  actualProductHeight?: number
): SheetSize {
  throw new Error('findBestFitSheetSize is deprecated. Use backend API response instead.');
}

export function calculateMaterialUtilization(
  requiredWidth: number, 
  requiredHeight: number, 
  sheetSize: SheetSize
): number {
  throw new Error('calculateMaterialUtilization is deprecated. Use backend API response instead.');
}

export function calculateBoxesPerSheet(
  boxLength: number,
  boxWidth: number,
  sheetSize: SheetSize
): { 
  boxesPerSheet: number;
  orientation: string;
} {
  throw new Error('calculateBoxesPerSheet is deprecated. Use backend API response instead.');
}